import axios from 'axios';
import { API } from '../../lib/api';

/**
 * Cliente de las páginas públicas del calendario (reservar, gestionar una cita, responder una invitación).
 * Sin sesión a propósito: no lleva el token del portal aunque quien la abre tenga una cuenta, ni pasa por el
 * interceptor que manda a /login con un 401.
 */
export const apiPublica = axios.create({ baseURL: API });

export const errorDe = (e, defecto = 'Algo salió mal') => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : defecto;
};
